export function Brand() {
  return (
    <div className="brand">
      <span className="brand-mark" aria-hidden="true">BT</span>
      <span>Bingo App</span>
    </div>
  );
}
